import faker from 'faker'
import _ from 'lodash'
import moment from 'moment'
import hrms6keLabels from 'assets/labels/hrms6ke'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    let typotDropdown = {}
    let key = ''
    const totalTypotDropdown = 5 + Math.floor(Math.random() * 6)
    for (var i = 1; i < totalTypotDropdown; i++) {
      key = _.padStart(faker.lorem.word(), 4, '0')
      typotDropdown[key] = faker.lorem.word()
    }
    return {
      labels: hrms6keLabels,
      dropdowns: {
        typot: {
          en: typotDropdown,
          th: typotDropdown
        }
      }
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        // dtereq: moment().format('DD/MM/YYYY'),
        // numseq: faker.random.number().toString().substr(0, 1),
        // numotreq: faker.random.number().toString().substr(0, 1),
        // dterange: moment().format('DD/MM/YYYY') + ' - ' + moment().format('DD/MM/YYYY'),
        // staappr: faker.lorem.word(),
        // desc_stareq: faker.lorem.word(),
        // remarkap: faker.lorem.sentence(),
        // desc_codappr: faker.lorem.word(),
        // desc_codempap: faker.lorem.word(),
        numotgen: faker.random.word(),
        dtereq: moment().format('DD/MM/YYYY') + ' - ' + moment().format('DD/MM/YYYY'),
        timbstr: moment().format('HH:mm') + ' - ' + moment().format('HH:mm'),
        timdstr: moment().format('HH:mm') + ' - ' + moment().format('HH:mm'),
        timastr: moment().format('HH:mm') + ' - ' + moment().format('HH:mm'),
        desc_codcomp: faker.name.jobTitle()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  currentNumseq () {
    return 1
  },
  create () {
    let mockTab1 = {
      numotgen: '',
      codempid: '',
      numseq: '',
      dtereq: moment().format('DD/MM/YYYY'),
      staappr: '',
      routeno: '',
      dtestrt: moment().format('DD/MM/YYYY'),
      dteend: moment().format('DD/MM/YYYY'),
      timbstr: '',
      timbend: '',
      timdstr: '',
      timdend: '',
      timastr: '',
      timaend: '',
      codrem: '',
      remark: '',
      codcomp: '',
      codcalen: '',
      codshift: ''
    }

    return {
      tab1: mockTab1,
      tab2: {
        total: 0,
        rows: []
      }
    }
  },
  detail () {
    let mockTab1 = {
      codempid: faker.lorem.word(),
      numseq: faker.random.number().toString().substr(0, 1),
      dtereq: moment().format('DD/MM/YYYY'),
      staappr: faker.lorem.word(),
      routeno: faker.lorem.word(),
      dtestrt: moment().format('DD/MM/YYYY'),
      dteend: moment().format('DD/MM/YYYY'),
      timbstr: faker.date.past().toString().substr(16, 5),
      timbend: faker.date.past().toString().substr(16, 5),
      timdstr: faker.date.past().toString().substr(16, 5),
      timdend: faker.date.past().toString().substr(16, 5),
      timastr: faker.date.past().toString().substr(16, 5),
      timaend: faker.date.past().toString().substr(16, 5),
      codrem: faker.lorem.word(),
      remark: faker.lorem.word(),
      codcomp: 'TJS',
      codcalen: '',
      codshift: 'SL'
    }
    let mockTab2Rows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTab2Total = 5
    for (var i = 1; i <= mockTab2Total; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockTab2Rows.push({
        dtestrt: moment().format('DD/MM/YYYY'),
        codempid: faker.lorem.word(),
        // empname: faker.name.findName(),
        desc_codempid: faker.name.findName(),
        codshift: faker.lorem.word(),
        v_timstrt: moment().format('HH:mm'),
        v_timend: moment().format('HH:mm'),
        v_staappr: mockStatus[staappr],
        staappr: ''
      })
    }

    return {
      tab1: mockTab1,
      tab2: {
        total: mockTab2Total,
        rows: mockTab2Rows
      }
    }
  },
  detailTab2Process (param) {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    let typot = ''
    const mockTypot = [ 'A', 'B', 'D' ]
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      typot = mockTypot[Math.floor(Math.random() * 3)]
      mockRows.push({
        dtestrt: moment().format('DD/MM/YYYY'),
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        typot: typot,
        codshift: faker.lorem.word(),
        v_timstrt: moment().format('HH:mm'),
        v_timend: moment().format('HH:mm'),
        v_staappr: mockStatus[staappr],
        staappr: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detailTab2AddInline (param) {
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    staappr = mockStaappr[Math.floor(Math.random() * 5)]
    return {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      codshift: faker.lorem.word(),
      v_staappr: mockStatus[staappr]
    }
  },
  dropdowns () {
    let mockCodremEn = {}
    let mockCodremTh = {}
    const mockTotal = Math.floor(Math.random() * 15) + 10
    for (var i = 1; i <= mockTotal; i++) {
      mockCodremEn[faker.lorem.word()] = faker.lorem.word()
      mockCodremTh[faker.lorem.word()] = faker.lorem.word()
    }
    return {
      codrem: {
        en: mockCodremEn,
        th: mockCodremTh
      }
    }
  },
  save () {
    return labels.mockPostMessage
  },
  delete () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms6ke/mocker.js